export default __webpack_public_path__ + "static/media/mod03.7ff4bec4.svg";